// This file is autogenerated by running npx ts-node scripts/transforms/phone-country-codes/index.ts

interface Idd {
  root?: string
  suffixes?: string[] | undefined
}

export const getPhoneCode = (country?: string | null): string => {
  if (!country) return ''
  const idd = getPhoneCodeData(country)

  if (!idd || !idd.root) return ''
  if (!idd.suffixes) return idd.root

  // for now we are returning the first suffix, but
  // we should handle this properly since for some countries,
  // like US, it has may options as suffixes.
  return `${idd.root}${idd.suffixes[0] ?? ''}`
}

function getPhoneCodeData(country: string): Idd | undefined {
  return countryData.get(country.toUpperCase())
}

const countryData: Map<string, Idd> = new Map([
  ['BB', { root: '+1', suffixes: ['246'] }],
  ['IO', { root: '+2', suffixes: ['46'] }],
  ['CG', { root: '+2', suffixes: ['42'] }],
  ['BR', { root: '+5', suffixes: ['5'] }],
  ['LU', { root: '+3', suffixes: ['52'] }],
  ['VI', { root: '+1', suffixes: ['340'] }],
  ['KI', { root: '+6', suffixes: ['86'] }],
  ['RO', { root: '+4', suffixes: ['0'] }],
  ['LA', { root: '+8', suffixes: ['56'] }],
  ['MT', { root: '+3', suffixes: ['56'] }],
  ['TG', { root: '+2', suffixes: ['28'] }],
  ['IQ', { root: '+9', suffixes: ['64'] }],
  ['KE', { root: '+2', suffixes: ['54'] }],
  ['KY', { root: '+1', suffixes: ['345'] }],
  ['GN', { root: '+2', suffixes: ['24'] }],
  [
    'US',
    {
      root: '+1',
      suffixes: [
        '201',
        '202',
        '203',
        '205',
        '206',
        '207',
        '208',
        '209',
        '210',
        '212',
        '213',
        '214',
        '215',
        '216',
        '217',
        '218',
        '219',
        '220',
        '224',
        '225',
        '227',
        '228',
        '229',
        '231',
        '234',
        '239',
        '240',
        '248',
        '251',
        '252',
        '253',
        '254',
        '256',
        '260',
        '262',
        '267',
        '269',
        '270',
        '272',
        '274',
        '276',
        '281',
        '283',
        '301',
        '302',
        '303',
        '304',
        '305',
        '307',
        '308',
        '309',
        '310',
        '312',
        '313',
        '314',
        '315',
        '316',
        '317',
        '318',
        '319',
        '320',
        '321',
        '323',
        '325',
        '327',
        '330',
        '331',
        '334',
        '336',
        '337',
        '339',
        '346',
        '347',
        '351',
        '352',
        '360',
        '361',
        '364',
        '380',
        '385',
        '386',
        '401',
        '402',
        '404',
        '405',
        '406',
        '407',
        '408',
        '409',
        '410',
        '412',
        '413',
        '414',
        '415',
        '417',
        '419',
        '423',
        '424',
        '425',
        '430',
        '432',
        '434',
        '435',
        '440',
        '442',
        '443',
        '447',
        '458',
        '463',
        '464',
        '469',
        '470',
        '475',
        '478',
        '479',
        '480',
        '484',
        '501',
        '502',
        '503',
        '504',
        '505',
        '507',
        '508',
        '509',
        '510',
        '512',
        '513',
        '515',
        '516',
        '517',
        '518',
        '520',
        '530',
        '531',
        '534',
        '539',
        '540',
        '541',
        '551',
        '559',
        '561',
        '562',
        '563',
        '564',
        '567',
        '570',
        '571',
        '573',
        '574',
        '575',
        '580',
        '585',
        '586',
        '601',
        '602',
        '603',
        '605',
        '606',
        '607',
        '608',
        '609',
        '610',
        '612',
        '614',
        '615',
        '616',
        '617',
        '618',
        '619',
        '620',
        '623',
        '626',
        '628',
        '629',
        '630',
        '631',
        '636',
        '641',
        '646',
        '650',
        '651',
        '657',
        '660',
        '661',
        '662',
        '667',
        '669',
        '678',
        '681',
        '682',
        '701',
        '702',
        '703',
        '704',
        '706',
        '707',
        '708',
        '712',
        '713',
        '714',
        '715',
        '716',
        '717',
        '718',
        '719',
        '720',
        '724',
        '725',
        '727',
        '730',
        '731',
        '732',
        '734',
        '737',
        '740',
        '743',
        '747',
        '754',
        '757',
        '760',
        '762',
        '763',
        '765',
        '769',
        '770',
        '772',
        '773',
        '774',
        '775',
        '779',
        '781',
        '785',
        '786',
        '801',
        '802',
        '803',
        '804',
        '805',
        '806',
        '808',
        '810',
        '812',
        '813',
        '814',
        '815',
        '816',
        '817',
        '818',
        '828',
        '830',
        '831',
        '832',
        '843',
        '845',
        '847',
        '848',
        '850',
        '854',
        '856',
        '857',
        '858',
        '859',
        '860',
        '862',
        '863',
        '864',
        '865',
        '870',
        '872',
        '878',
        '901',
        '903',
        '904',
        '906',
        '907',
        '908',
        '909',
        '910',
        '912',
        '913',
        '914',
        '915',
        '916',
        '917',
        '918',
        '919',
        '920',
        '925',
        '928',
        '929',
        '930',
        '931',
        '934',
        '936',
        '937',
        '938',
        '940',
        '941',
        '947',
        '949',
        '951',
        '952',
        '954',
        '956',
        '959',
        '970',
        '971',
        '972',
        '973',
        '975',
        '978',
        '979',
        '980',
        '984',
        '985',
        '989',
      ],
    },
  ],
  ['TN', { root: '+2', suffixes: ['16'] }],
  ['BO', { root: '+5', suffixes: ['91'] }],
  ['CN', { root: '+8', suffixes: ['6'] }],
  ['KR', { root: '+8', suffixes: ['2'] }],
  ['KW', { root: '+9', suffixes: ['65'] }],
  ['DZ', { root: '+2', suffixes: ['13'] }],
  ['AW', { root: '+2', suffixes: ['97'] }],
  ['RU', { root: '+7', suffixes: ['3', '4', '5', '8', '9'] }],
  ['DK', { root: '+4', suffixes: ['5'] }],
  ['LT', { root: '+3', suffixes: ['70'] }],
  ['GB', { root: '+4', suffixes: ['4'] }],
  ['EE', { root: '+3', suffixes: ['72'] }],
  ['TW', { root: '+8', suffixes: ['86'] }],
  ['CA', { root: '+1', suffixes: [''] }],
  ['FJ', { root: '+6', suffixes: ['79'] }],
  ['PF', { root: '+6', suffixes: ['89'] }],
  ['PE', { root: '+5', suffixes: ['1'] }],
  ['AU', { root: '+6', suffixes: ['1'] }],
  ['CL', { root: '+5', suffixes: ['6'] }],
  ['YT', { root: '+2', suffixes: ['62'] }],
  ['EG', { root: '+2', suffixes: ['0'] }],
  ['PR', { root: '+1', suffixes: ['787', '939'] }],
  ['MK', { root: '+3', suffixes: ['89'] }],
  ['BD', { root: '+8', suffixes: ['80'] }],
  ['MF', { root: '+5', suffixes: ['90'] }],
  ['SG', { root: '+6', suffixes: ['5'] }],
  ['GA', { root: '+2', suffixes: ['41'] }],
  ['PT', { root: '+3', suffixes: ['51'] }],
  ['ET', { root: '+2', suffixes: ['51'] }],
  ['BS', { root: '+1', suffixes: ['242'] }],
  ['VA', { root: '+3', suffixes: ['906698', '79'] }],
  ['BF', { root: '+2', suffixes: ['26'] }],
  ['TM', { root: '+9', suffixes: ['93'] }],
  ['MP', { root: '+1', suffixes: ['670'] }],
  ['SX', { root: '+1', suffixes: ['721'] }],
  ['ZM', { root: '+2', suffixes: ['60'] }],
  ['HN', { root: '+5', suffixes: ['04'] }],
  ['MA', { root: '+2', suffixes: ['12'] }],
  ['NP', { root: '+9', suffixes: ['77'] }],
  ['AG', { root: '+1', suffixes: ['268'] }],
  ['OM', { root: '+9', suffixes: ['68'] }],
  ['HK', { root: '+8', suffixes: ['52'] }],
  ['GL', { root: '+2', suffixes: ['99'] }],
  ['PY', { root: '+5', suffixes: ['95'] }],
  ['MD', { root: '+3', suffixes: ['73'] }],
  ['NC', { root: '+6', suffixes: ['87'] }],
  ['KG', { root: '+9', suffixes: ['96'] }],
  ['MU', { root: '+2', suffixes: ['30'] }],
  ['BT', { root: '+9', suffixes: ['75'] }],
  ['CF', { root: '+2', suffixes: ['36'] }],
  ['BL', { root: '+5', suffixes: ['90'] }],
  ['CY', { root: '+3', suffixes: ['57'] }],
  ['RE', { root: '+2', suffixes: ['62'] }],
  ['TD', { root: '+2', suffixes: ['35'] }],
  ['GR', { root: '+3', suffixes: ['0'] }],
  ['MS', { root: '+1', suffixes: ['664'] }],
  ['YE', { root: '+9', suffixes: ['67'] }],
  ['IM', { root: '+4', suffixes: ['4'] }],
  ['DO', { root: '+1', suffixes: ['809', '829', '849'] }],
  ['GG', { root: '+4', suffixes: ['4'] }],
  ['LR', { root: '+2', suffixes: ['31'] }],
  ['ZW', { root: '+2', suffixes: ['63'] }],
  ['GP', { root: '+5', suffixes: ['90'] }],
  ['UG', { root: '+2', suffixes: ['56'] }],
  ['VU', { root: '+6', suffixes: ['78'] }],
  ['UM', { root: '+2', suffixes: ['68'] }],
  ['PS', { root: '+9', suffixes: ['70'] }],
  ['PK', { root: '+9', suffixes: ['2'] }],
  ['HM', { root: 'undefined', suffixes: undefined }],
  ['IN', { root: '+9', suffixes: ['1'] }],
  ['BN', { root: '+6', suffixes: ['73'] }],
  ['AE', { root: '+9', suffixes: ['71'] }],
  ['EC', { root: '+5', suffixes: ['93'] }],
  ['GE', { root: '+9', suffixes: ['95'] }],
  ['GU', { root: '+1', suffixes: ['671'] }],
  ['SC', { root: '+2', suffixes: ['48'] }],
  ['FK', { root: '+5', suffixes: ['00'] }],
  ['GI', { root: '+3', suffixes: ['50'] }],
  ['SB', { root: '+6', suffixes: ['77'] }],
  ['UZ', { root: '+9', suffixes: ['98'] }],
  ['MN', { root: '+9', suffixes: ['76'] }],
  ['GY', { root: '+5', suffixes: ['92'] }],
  ['BA', { root: '+3', suffixes: ['87'] }],
  ['TO', { root: '+6', suffixes: ['76'] }],
  ['FR', { root: '+3', suffixes: ['3'] }],
  ['SI', { root: '+3', suffixes: ['86'] }],
  ['RW', { root: '+2', suffixes: ['50'] }],
  ['BG', { root: '+3', suffixes: ['59'] }],
  ['TL', { root: '+6', suffixes: ['70'] }],
  ['NG', { root: '+2', suffixes: ['34'] }],
  ['GS', { root: '+5', suffixes: ['00'] }],
  ['NR', { root: '+6', suffixes: ['74'] }],
  ['FO', { root: '+2', suffixes: ['98'] }],
  ['AS', { root: '+1', suffixes: ['684'] }],
  ['LS', { root: '+2', suffixes: ['66'] }],
  ['ME', { root: '+3', suffixes: ['82'] }],
  ['CV', { root: '+2', suffixes: ['38'] }],
  ['CM', { root: '+2', suffixes: ['37'] }],
  ['KP', { root: '+8', suffixes: ['50'] }],
  ['CU', { root: '+5', suffixes: ['3'] }],
  ['SR', { root: '+5', suffixes: ['97'] }],
  ['NZ', { root: '+6', suffixes: ['4'] }],
  ['MX', { root: '+5', suffixes: ['2'] }],
  ['MH', { root: '+6', suffixes: ['92'] }],
  ['PH', { root: '+6', suffixes: ['3'] }],
  ['SE', { root: '+4', suffixes: ['6'] }],
  ['BV', { root: '+4', suffixes: ['7'] }],
  ['JM', { root: '+1', suffixes: ['876'] }],
  ['VE', { root: '+5', suffixes: ['8'] }],
  ['JE', { root: '+4', suffixes: ['4'] }],
  ['AF', { root: '+9', suffixes: ['3'] }],
  ['MO', { root: '+8', suffixes: ['53'] }],
  ['AX', { root: '+3', suffixes: ['5818'] }],
  ['SY', { root: '+9', suffixes: ['63'] }],
  ['ST', { root: '+2', suffixes: ['39'] }],
  ['CH', { root: '+4', suffixes: ['1'] }],
  ['SM', { root: '+3', suffixes: ['78'] }],
  ['SZ', { root: '+2', suffixes: ['68'] }],
  ['VC', { root: '+1', suffixes: ['784'] }],
  ['MY', { root: '+6', suffixes: ['0'] }],
  ['DE', { root: '+4', suffixes: ['9'] }],
  ['PL', { root: '+4', suffixes: ['8'] }],
  ['GD', { root: '+1', suffixes: ['473'] }],
  ['SS', { root: '+2', suffixes: ['11'] }],
  ['BE', { root: '+3', suffixes: ['2'] }],
  ['KH', { root: '+8', suffixes: ['55'] }],
  ['LK', { root: '+9', suffixes: ['4'] }],
  ['CI', { root: '+2', suffixes: ['25'] }],
  ['GH', { root: '+2', suffixes: ['33'] }],
  ['ER', { root: '+2', suffixes: ['91'] }],
  ['BZ', { root: '+5', suffixes: ['01'] }],
  ['CX', { root: '+6', suffixes: ['1'] }],
  ['GQ', { root: '+2', suffixes: ['40'] }],
  ['TT', { root: '+1', suffixes: ['868'] }],
  ['CK', { root: '+6', suffixes: ['82'] }],
  ['ML', { root: '+2', suffixes: ['23'] }],
  ['SH', { root: '+2', suffixes: ['90', '47'] }],
  ['CC', { root: '+6', suffixes: ['1'] }],
  ['MZ', { root: '+2', suffixes: ['58'] }],
  ['IR', { root: '+9', suffixes: ['8'] }],
  ['CD', { root: '+2', suffixes: ['43'] }],
  ['PW', { root: '+6', suffixes: ['80'] }],
  ['MV', { root: '+9', suffixes: ['60'] }],
  ['BJ', { root: '+2', suffixes: ['29'] }],
  ['JO', { root: '+9', suffixes: ['62'] }],
  ['MC', { root: '+3', suffixes: ['77'] }],
  ['MR', { root: '+2', suffixes: ['22'] }],
  ['CZ', { root: '+4', suffixes: ['20'] }],
  ['BY', { root: '+3', suffixes: ['75'] }],
  ['AL', { root: '+3', suffixes: ['55'] }],
  ['MW', { root: '+2', suffixes: ['65'] }],
  ['SO', { root: '+2', suffixes: ['52'] }],
  ['RS', { root: '+3', suffixes: ['81'] }],
  ['IS', { root: '+3', suffixes: ['54'] }],
  ['WS', { root: '+6', suffixes: ['85'] }],
  ['MM', { root: '+9', suffixes: ['5'] }],
  ['TH', { root: '+6', suffixes: ['6'] }],
  ['LB', { root: '+9', suffixes: ['61'] }],
  ['LV', { root: '+3', suffixes: ['71'] }],
  ['KZ', { root: '+7', suffixes: ['6', '7'] }],
  ['MQ', { root: '+5', suffixes: ['96'] }],
  ['PN', { root: '+6', suffixes: ['4'] }],
  ['TV', { root: '+6', suffixes: ['88'] }],
  ['HU', { root: '+3', suffixes: ['6'] }],
  ['SJ', { root: '+4', suffixes: ['779'] }],
  ['KM', { root: '+2', suffixes: ['69'] }],
  ['IL', { root: '+9', suffixes: ['72'] }],
  ['SD', { root: '+2', suffixes: ['49'] }],
  ['AM', { root: '+3', suffixes: ['74'] }],
  ['UY', { root: '+5', suffixes: ['98'] }],
  ['VG', { root: '+1', suffixes: ['284'] }],
  ['SA', { root: '+9', suffixes: ['66'] }],
  ['DM', { root: '+1', suffixes: ['767'] }],
  ['TK', { root: '+6', suffixes: ['90'] }],
  ['BI', { root: '+2', suffixes: ['57'] }],
  ['UA', { root: '+3', suffixes: ['80'] }],
  ['AT', { root: '+4', suffixes: ['3'] }],
  ['SL', { root: '+2', suffixes: ['32'] }],
  ['BM', { root: '+1', suffixes: ['441'] }],
  ['NA', { root: '+2', suffixes: ['64'] }],
  ['NL', { root: '+3', suffixes: ['1'] }],
  ['XK', { root: '+3', suffixes: ['83'] }],
  ['HT', { root: '+5', suffixes: ['09'] }],
  ['ES', { root: '+3', suffixes: ['4'] }],
  ['IE', { root: '+3', suffixes: ['53'] }],
  ['LY', { root: '+2', suffixes: ['18'] }],
  ['PG', { root: '+6', suffixes: ['75'] }],
  ['LC', { root: '+1', suffixes: ['758'] }],
  ['NF', { root: '+6', suffixes: ['72'] }],
  ['AO', { root: '+2', suffixes: ['44'] }],
  ['ID', { root: '+6', suffixes: ['2'] }],
  ['NO', { root: '+4', suffixes: ['7'] }],
  ['AR', { root: '+5', suffixes: ['4'] }],
  ['PA', { root: '+5', suffixes: ['07'] }],
  ['JP', { root: '+8', suffixes: ['1'] }],
  ['SV', { root: '+5', suffixes: ['03'] }],
  ['AD', { root: '+3', suffixes: ['76'] }],
  ['NE', { root: '+2', suffixes: ['27'] }],
  ['NI', { root: '+5', suffixes: ['05'] }],
  ['WF', { root: '+6', suffixes: ['81'] }],
  ['IT', { root: '+3', suffixes: ['9'] }],
  ['PM', { root: '+5', suffixes: ['08'] }],
  ['GW', { root: '+2', suffixes: ['45'] }],
  ['TZ', { root: '+2', suffixes: ['55'] }],
  ['SK', { root: '+4', suffixes: ['21'] }],
  ['TF', { root: '+2', suffixes: ['62'] }],
  ['FI', { root: '+3', suffixes: ['58'] }],
  ['LI', { root: '+4', suffixes: ['23'] }],
  ['TJ', { root: '+9', suffixes: ['92'] }],
  ['GT', { root: '+5', suffixes: ['02'] }],
  ['TC', { root: '+1', suffixes: ['649'] }],
  ['AQ', { root: 'undefined', suffixes: undefined }],
  ['BH', { root: '+9', suffixes: ['73'] }],
  ['MG', { root: '+2', suffixes: ['61'] }],
  ['EH', { root: '+2', suffixes: ['125288', '125289'] }],
  ['FM', { root: '+6', suffixes: ['91'] }],
  ['ZA', { root: '+2', suffixes: ['7'] }],
  ['BQ', { root: '+5', suffixes: ['99'] }],
  ['DJ', { root: '+2', suffixes: ['53'] }],
  ['SN', { root: '+2', suffixes: ['21'] }],
  ['GM', { root: '+2', suffixes: ['20'] }],
  ['BW', { root: '+2', suffixes: ['67'] }],
  ['GF', { root: '+5', suffixes: ['94'] }],
  ['KN', { root: '+1', suffixes: ['869'] }],
  ['TR', { root: '+9', suffixes: ['0'] }],
  ['AZ', { root: '+9', suffixes: ['94'] }],
  ['CR', { root: '+5', suffixes: ['06'] }],
  ['CW', { root: '+5', suffixes: ['99'] }],
  ['VN', { root: '+8', suffixes: ['4'] }],
  ['HR', { root: '+3', suffixes: ['85'] }],
  ['NU', { root: '+6', suffixes: ['83'] }],
  ['AI', { root: '+1', suffixes: ['264'] }],
  ['QA', { root: '+9', suffixes: ['74'] }],
  ['CO', { root: '+5', suffixes: ['7'] }],
])
